module.exports = __webpack_public_path__ + "img/91423.6d17027f.svg";